// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* General Styles */
.home {
  font-family: "Poppins", sans-serif;
  color: #333;
  scroll-behavior: smooth;
}

/* Hero Section */
.hero-section {
  position: relative;
  height: 100vh;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  color: white;
  overflow: hidden;
  border-radius: 0px !important;
}

.hero-video {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: -1;
  border-radius: 0px;
}

.hero-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  z-index: 0;
}

.hero-content {
  position: relative;
  z-index: 1;
  max-width: 800px;
  padding: 20px;
  border-radius: 10px;
}

.hero-content h1 {
  font-family: "Montserrat", sans-serif;
  font-size: 2.5rem;
  margin-bottom: 10px;
  font-weight: 600;
  animation: fadeInDown 1.5s ease;
  line-height: 1.2;
}

.hero-content p {
  font-family: "Roboto", sans-serif;
  font-size: 1.4rem;
  animation: fadeInUp 1.5s ease;
  color: #f0f0f0;
}

.hero-content button {
  padding: 15px 30px;
  font-size: 1.2rem;
  background-color: #ff6b6b;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: all 0.3s ease;
  animation: float 3s infinite;
}

.hero-content button:hover {
  background-color: #ff4c4c;
  transform: translateY(-5px);
}

@keyframes fadeInDown {
  from {
    opacity: 0;
    transform: translateY(-50px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(50px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes float {
  0% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-10px);
  }
  100% {
    transform: translateY(0);
  }
}

/* Mission Section */
.mission-section {
  padding: 0px 20px;
  text-align: center;
  background-color: #f9f9f9;
}

.mission-section h2 {
  font-family: "Montserrat", sans-serif;
  font-size: 2.5rem;
  margin-bottom: 15px;
  font-weight: 20px;
}

.mission-description {
  font-family: "Montserrat", sans-serif;
  font-size: 1.1rem;
  color: #555;
  max-width: 1200px;
  margin: 0 auto;
  line-height: 1.6;
  margin-bottom: 50px;
  text-align: start;
}

.mission-cards {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 20px;
}

.mission-card {
  background-color: white;
  padding: 20px;
  border-radius: 0px;
  width: 300px;
  height: 200px;
  text-align: center;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  cursor: pointer;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  background-size: cover;
  background-position: center;
}

.mission-card h3 {
  font-family: "Montserrat", sans-serif;
  font-size: 1.5rem;
  margin-bottom: 10px;
}

.mission-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
}

/* Features Section */
.features-section {
  padding: 80px 20px;
  text-align: center;
  background-color: white;
}

.features-section h2 {
  font-family: "Montserrat", sans-serif;
  font-size: 2.5rem;
  margin-bottom: 40px;
}

.features-grid {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 20px;
}

.feature-card {
  background-color: #f9f9f9;
  padding: 30px;
  border-radius: 10px;
  width: 300px;
  text-align: start;
  transition: all 0.3s ease;
  font-family: "Montserrat", sans-serif;
  position: relative;
}

.feature-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
}

.feature-icon {
  font-size: 3rem;
  color: #ff6b6b;
  margin-bottom: 20px;
}

.feature-card h3 {
  font-family: "Montserrat", sans-serif;
  font-size: 1.5rem;
  margin-bottom: 10px;
}

.feature-card p {
  font-family: "Montserrat", sans-serif;
  font-size: 1.1rem;
  color: #555;
}

/* Nature Mission Card Specific Styles */
.nature-mission-card {
  position: relative;
  overflow: hidden;
  background: linear-gradient(135deg, #3c433c, #45a049) !important;
  color: white !important;
  text-decoration: none;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 50px;
}

.nature-mission-card .feature-icon {
  color: white !important;
}

.nature-mission-card h3,
.nature-mission-card p {
  color: white !important;
}

.nature-mission-card .learn-more {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(255, 255, 255, 0.1);
  padding: 12px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  transition: all 0.3s ease;
  backdrop-filter: blur(5px);
  border-top: 1px solid rgba(255, 255, 255, 0.2);
}

.nature-mission-card:hover .learn-more {
  background: rgba(255, 255, 255, 0.2);
  padding-left: 20px;
  padding-right: 20px;
}

.nature-mission-card .learn-more span {
  font-size: 0.95rem;
  font-weight: 600;
  color: white;
}

.nature-mission-card .arrow-icon {
  font-size: 0.9rem;
  color: white;
  transition: transform 0.3s ease;
}

.nature-mission-card:hover .arrow-icon {
  transform: translateX(5px);
}

.nature-mission-card:hover {
  transform: translateY(-10px) scale(1.02);
  box-shadow: 0 15px 30px rgba(76, 175, 80, 0.3);
}

/* Testimonials Section */
.testimonials-section {
  padding: 80px 20px;
  text-align: center;
  background-color: #f9f9f9;
}

.testimonials-section h2 {
  font-family: "Montserrat", sans-serif;
  font-size: 2.5rem;
  margin-bottom: 40px;
}

.testimonials-grid {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 20px;
}

.testimonial-card {
  background-color: white;
  padding: 30px;
  border-radius: 10px;
  width: 300px;
  text-align: start;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.testimonial-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
}

.quote-icon {
  font-size: 2rem;
  color: #ff6b6b;
  margin-bottom: 20px;
}

.testimonial-card p {
  font-size: 1.1rem;
  color: #555;
  margin-bottom: 10px;
  font-family: "Montserrat", sans-serif;
}

/* Call-to-Action Section */
.cta-section {
  padding: 40px 20px;
  text-align: center;
  background: linear-gradient(135deg, #1e3c72, #2a5298);
  color: white;
  position: relative;
  overflow: hidden;
}

.cta-section::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.1);
  z-index: 1;
}

.cta-content {
  position: relative;
  z-index: 2;
  max-width: 800px;
  margin: 0 auto;
}

.cta-section h2 {
  font-size: 2.5rem;
  margin-bottom: 20px;
  font-weight: bold;
  animation: fadeInDown 1.5s ease;
}

.cta-section p {
  font-size: 1.2rem;
  margin-bottom: 40px;
  animation: fadeInUp 1.5s ease;
}

.cta-section button {
  padding: 15px 30px;
  font-size: 1.2rem;
  background-color: white;
  color: #6a11cb;
  border: none;
  border-radius: 50px;
  cursor: pointer;
  transition: all 0.3s ease;
  animation: pulse 2s infinite;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
}

.cta-section button:hover {
  background-color: #f0f0f0;
  transform: translateY(-5px);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.3);
}

@keyframes pulse {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
  100% {
    transform: scale(1);
  }
}

/* FOOTER - COMPLETE FIX FOR ALL SCREEN SIZES */
.footer {
  padding: 50px 20px 20px 20px;
  background-color: #333;
  color: white;
  font-family: "Montserrat", sans-serif;
  width: 100%;
  box-sizing: border-box;
  position: relative;
  z-index: 1;
}

.footer-content {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 40px;
  max-width: 1200px;
  margin: 0 auto 40px auto;
  padding: 0 20px;
  position: relative;
  z-index: 10;
}

.footer-section {
  flex: 1 1;
  min-width: 250px;
  max-width: 300px;
  position: relative;
  z-index: 20;
}

.footer-section h3 {
  font-size: 1.5rem;
  margin-bottom: 20px;
  color: white;
  font-weight: 600;
  position: relative;
  padding-bottom: 10px;
}

.footer-section p {
  font-size: 1rem;
  color: #ccc;
  line-height: 1.6;
  margin-bottom: 10px;
}

.footer-section ul {
  list-style: none;
  padding: 0;
  margin: 0;
  position: relative;
  z-index: 20;
}

.footer-section ul li {
  margin-bottom: 12px;
  position: relative;
  z-index: 20;
}

.footer-section ul li a {
  color: #ccc;
  text-decoration: none;
  transition: color 0.3s ease;
  font-size: 1rem;
  display: inline-block;
  padding: 4px 0;
  position: relative;
  z-index: 30;
  pointer-events: auto;
}

.footer-section ul li a:hover {
  color: #ff6b6b;
  transform: translateX(5px);
}


.footer-section .social-links {
  display: flex;
  gap: 4px;
  margin-top: 10px;
  position: relative;
  z-index: 1000;
  justify-content: flex-start; 
  margin-left: 0;
}

.footer-section .social-links a {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  text-decoration: none !important;
  transition: all 0.3s ease;
  position: relative;
  z-index: 1001;
  cursor: pointer !important;
  pointer-events: auto !important;
  outline: none;
  border: none;
  background-clip: padding-box;
}


.footer-section .social-links a,
.footer-section .social-links a:focus,
.footer-section .social-links a:active,
.footer-section .social-links a:visited {
  text-decoration: none !important;
  outline: none !important;
}

/* Facebook */
.footer-section .social-links a:nth-child(1) {
  background-color: #1877F2 !important;
}

.footer-section .social-links a:nth-child(1):hover {
  background-color: #0d65d9 !important;
  transform: translateY(-3px) scale(1.1);
  box-shadow: 0 4px 12px rgba(24, 119, 242, 0.3);
}


.footer-section .social-links a:nth-child(2) {
  background-color: #0077B5 !important;
  position: relative;
  z-index: 1002 !important;
}

.footer-section .social-links a:nth-child(2):hover {
  background-color: #005582 !important;
  transform: translateY(-3px) scale(1.1);
  box-shadow: 0 4px 12px rgba(0, 119, 181, 0.3);
}

/* Social link icons */
.footer-section .social-links a svg {
  color: white !important;
  font-size: 1.2rem;
  position: relative;
  z-index: 1003;
  pointer-events: none;
}

/* LEGAL LINKS SECTION */
.footer-legal-links {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 20px;
  padding: 15px 10px;
  border-top: 1px solid #444;
  border-bottom: 1px solid #444;
  background: transparent;
  position: relative;
  z-index: 5;
  margin-top: 20px;
}

.footer-legal-links a {
  font-size: 0.85rem;
  color: #aaa;
  text-decoration: none;
  font-family: "Montserrat", sans-serif;
  transition: all 0.3s ease;
  white-space: nowrap;
  position: relative;
  z-index: 5;
  pointer-events: auto;
}

/* Fix for refund link */
.footer-legal-links a:nth-child(4) {
  max-width: 120px;
  text-align: center;
  word-break: break-word;
  white-space: normal;
  line-height: 1.3;
}

.footer-legal-links a:hover {
  color: #ff6b6b;
  text-decoration: underline;
}

.contactus-footer {
  text-align: center;
  margin-top: 20px;
  padding-top: 20px;
  width: 100%;
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
  position: relative;
  z-index: 5;
  border-top: 1px solid #444;
}

.contactus-footer p {
  font-size: 0.9rem;
  color: #aaa;
  margin: 0;
  padding: 0 20px;
}

/* Pop-up Overlay */
.popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

/* Pop-up Content */
.popup-content {
  background: white;
  padding: 30px;
  border-radius: 10px;
  text-align: center;
  max-width: 1200px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  position: relative;
  font-family: "Montserrat", sans-serif;
}

/* Close Icon */
.close-icon {
  position: absolute;
  top: 10px;
  right: 10px;
  font-size: 1.5rem;
  color: #6f6969;
  cursor: pointer;
  transition: color 0.3s ease;
}

.close-icon:hover {
  color: #837979;
}



/* For LARGE DESKTOPS (15" and above) - Social icons */
@media (min-width: 1200px) {
  .footer-section .social-links {
    justify-content: flex-start;
    margin-left: 0;
    padding-left: 0;
  }
}

/* For MEDIUM DESKTOPS/LAPTOPS (13"-14")  */
@media (min-width: 992px) and (max-width: 1199px) {
  .footer-section .social-links {
    justify-content: flex-start;
    margin-left: 0;
    padding-left: 0;
  }
  
  .footer-content {
    gap: 30px;
  }
  
  .footer-section {
    min-width: 220px;
  }
}

/* For SMALL DESKTOPS/TABLETS (11"-12")  */
@media (min-width: 768px) and (max-width: 991px) {
  .footer-section .social-links {
    justify-content: flex-start;
    margin-left: 0;
    padding-left: 0;
  }
  
  .footer-content {
    gap: 20px;
  }
  
  .footer-section {
    min-width: 200px;
  }
  
  .hero-content h1 {
    font-size: 2.2rem;
  }
  
  .mission-card,
  .feature-card,
  .testimonial-card {
    width: calc(50% - 20px);
  }
}

/* For TABLETS and MOBILE (below 768px)*/
@media (max-width: 767px) {
  .footer-section .social-links {
    justify-content: center;
  }
  
  .hero-content h1 {
    font-size: 2rem;
  }

  .hero-content p {
    font-size: 1rem;
  }

  .mission-card,
  .feature-card,
  .testimonial-card {
    width: 100%;
  }

  .cta-section h2 {
    font-size: 2rem;
  }

  .cta-section p {
    font-size: 1rem;
  }

  /* Footer Responsive */
  .footer {
    padding: 40px 15px 15px 15px;
  }
  
  .footer-content {
    flex-direction: column;
    gap: 30px;
    padding: 0 10px;
    margin-bottom: 30px;
    align-items: center;
    text-align: center;
  }
  
  .footer-section {
    min-width: 100%;
    max-width: 100%;
    text-align: center;
    padding: 0 10px;
  }
  
  .contactus-footer {
    padding-top: 15px;
    margin-top: 15px;
  }
  
  .contactus-footer p {
    font-size: 0.8rem;
  }
  
  /* Social links mobile */
  .footer-section .social-links a {
    width: 36px;
    height: 36px;
  }
  
  .footer-section .social-links a svg {
    font-size: 1rem;
  }
  
  /* Legal links mobile */
  .footer-legal-links {
    gap: 10px;
  }
  
  .footer-legal-links a {
    font-size: 0.8rem;
    padding: 4px 8px;
  }
  
  .footer-legal-links a:nth-child(4) {
    max-width: 100px;
  }
}

/* For SMALL MOBILE (below 480px) */
@media (max-width: 480px) {
  .hero-content h1 {
    font-size: 1.8rem;
  }

  .hero-content p {
    font-size: 0.9rem;
  }

  .mission-section h2,
  .features-section h2,
  .testimonials-section h2 {
    font-size: 2rem;
  }

  .mission-card,
  .feature-card,
  .testimonial-card {
    width: 100%;
    padding: 20px;
  }

  .cta-section h2 {
    font-size: 1.8rem;
  }

  .cta-section button {
    padding: 12px 24px;
    font-size: 1rem;
  }

  /* Footer Responsive */
  .footer {
    padding: 30px 10px 10px 10px;
  }
  
  .footer-content {
    gap: 25px;
  }
  
  .footer-section h3 {
    font-size: 1.3rem;
    margin-bottom: 15px;
  }
  
  .footer-section p, 
  .footer-section ul li a {
    font-size: 0.9rem;
  }
  
  .footer-section .social-links a {
    width: 32px;
    height: 32px;
  }
  
  .footer-section .social-links a svg {
    font-size: 0.9rem;
  }
  
  .footer-legal-links {
    gap: 8px;
  }
  
  .footer-legal-links a {
    font-size: 0.75rem;
  }
}

/* For VERY SMALL MOBILE (below 360px) */
@media (max-width: 360px) {
  .footer-section .social-links {
    gap: 10px;
  }
  
  .footer-section .social-links a {
    width: 30px;
    height: 30px;
  }
  
  .footer-section .social-links a svg {
    font-size: 0.85rem;
  }
}

@media (max-width: 768px) {
  .footer-section p {
    text-align: center;
    max-width: 300px;
    width: 100%;
    margin-left: auto;
    margin-right: auto;
    line-height: 1.7;
    word-break: break-word;
  }
}
/* Desktop & Laptop lo Follow Us icons inka left ki move */

@media (min-width: 768px) {

  /* Follow Us heading */
  .footer-section h3 {
    margin-left: -40px;
  }

   .footer-section p {
    margin-left: -40px;
  }


  /* Social icons */
  .footer-section .social-links {
    margin-left: -40px;
  }
}


`, "",{"version":3,"sources":["webpack://./src/components/Home.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB;EACE,kCAAkC;EAClC,WAAW;EACX,uBAAuB;AACzB;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,iBAAiB;EACjB,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,wBAAwB;EAC1B;AACF;;AAEA,oBAAoB;AACpB;EACE,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,qCAAqC;EACrC,iBAAiB;EACjB,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,wCAAwC;EACxC,yBAAyB;EACzB,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,qCAAqC;EACrC,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,0CAA0C;AAC5C;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,qCAAqC;EACrC,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,yBAAyB;EACzB,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,iBAAiB;EACjB,WAAW;AACb;;AAEA,wCAAwC;AACxC;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gEAAgE;EAChE,uBAAuB;EACvB,qBAAqB;EACrB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,oCAAoC;EACpC,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,yBAAyB;EACzB,0BAA0B;EAC1B,8CAA8C;AAChD;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,+BAA+B;AACjC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,wCAAwC;EACxC,8CAA8C;AAChD;;AAEA,yBAAyB;AACzB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,wCAAwC;EACxC,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;EAC5B,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA,2BAA2B;AAC3B;EACE,kBAAkB;EAClB,kBAAkB;EAClB,qDAAqD;EACrD,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,uBAAuB;EACvB,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,4BAA4B;EAC5B,yCAAyC;AAC3C;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,mBAAmB;EACrB;AACF;;AAEA,+CAA+C;AAC/C;EACE,4BAA4B;EAC5B,sBAAsB;EACtB,YAAY;EACZ,qCAAqC;EACrC,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,SAAS;EACT,iBAAiB;EACjB,wBAAwB;EACxB,eAAe;EACf,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,2BAA2B;EAC3B,eAAe;EACf,qBAAqB;EACrB,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;;AAGA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gCAAgC;EAChC,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,0BAA0B;EAC1B,+BAA+B;EAC/B,aAAa;EACb,YAAY;EACZ,4BAA4B;AAC9B;;;AAGA;;;;EAIE,gCAAgC;EAChC,wBAAwB;AAC1B;;AAEA,aAAa;AACb;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;EACtC,8CAA8C;AAChD;;;AAGA;EACE,oCAAoC;EACpC,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;EACtC,6CAA6C;AAC/C;;AAEA,sBAAsB;AACtB;EACE,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,oBAAoB;AACtB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,0BAA0B;EAC1B,6BAA6B;EAC7B,uBAAuB;EACvB,kBAAkB;EAClB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,qBAAqB;EACrB,qCAAqC;EACrC,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,oBAAoB;AACtB;;AAEA,wBAAwB;AACxB;EACE,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;EACX,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EACV,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,SAAS;EACT,eAAe;AACjB;;AAEA,mBAAmB;AACnB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA,mBAAmB;AACnB;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,wCAAwC;EACxC,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA,eAAe;AACf;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;;;AAIA,sDAAsD;AACtD;EACE;IACE,2BAA2B;IAC3B,cAAc;IACd,eAAe;EACjB;AACF;;AAEA,2CAA2C;AAC3C;EACE;IACE,2BAA2B;IAC3B,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA,0CAA0C;AAC1C;EACE;IACE,2BAA2B;IAC3B,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;;IAGE,uBAAuB;EACzB;AACF;;AAEA,wCAAwC;AACxC;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;;;IAGE,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA,sBAAsB;EACtB;IACE,4BAA4B;EAC9B;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,eAAe;IACf,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,eAAe;IACf,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA,wBAAwB;EACxB;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA,uBAAuB;EACvB;IACE,SAAS;EACX;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA,mCAAmC;AACnC;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;;IAGE,eAAe;EACjB;;EAEA;;;IAGE,WAAW;IACX,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA,sBAAsB;EACtB;IACE,4BAA4B;EAC9B;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;;IAEE,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA,wCAAwC;AACxC;EACE;IACE,SAAS;EACX;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;EACxB;AACF;AACA,0DAA0D;;AAE1D;;EAEE,sBAAsB;EACtB;IACE,kBAAkB;EACpB;;GAEC;IACC,kBAAkB;EACpB;;;EAGA,iBAAiB;EACjB;IACE,kBAAkB;EACpB;AACF","sourcesContent":["/* General Styles */\n.home {\n  font-family: \"Poppins\", sans-serif;\n  color: #333;\n  scroll-behavior: smooth;\n}\n\n/* Hero Section */\n.hero-section {\n  position: relative;\n  height: 100vh;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  color: white;\n  overflow: hidden;\n  border-radius: 0px !important;\n}\n\n.hero-video {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  z-index: -1;\n  border-radius: 0px;\n}\n\n.hero-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.6);\n  z-index: 0;\n}\n\n.hero-content {\n  position: relative;\n  z-index: 1;\n  max-width: 800px;\n  padding: 20px;\n  border-radius: 10px;\n}\n\n.hero-content h1 {\n  font-family: \"Montserrat\", sans-serif;\n  font-size: 2.5rem;\n  margin-bottom: 10px;\n  font-weight: 600;\n  animation: fadeInDown 1.5s ease;\n  line-height: 1.2;\n}\n\n.hero-content p {\n  font-family: \"Roboto\", sans-serif;\n  font-size: 1.4rem;\n  animation: fadeInUp 1.5s ease;\n  color: #f0f0f0;\n}\n\n.hero-content button {\n  padding: 15px 30px;\n  font-size: 1.2rem;\n  background-color: #ff6b6b;\n  color: white;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  animation: float 3s infinite;\n}\n\n.hero-content button:hover {\n  background-color: #ff4c4c;\n  transform: translateY(-5px);\n}\n\n@keyframes fadeInDown {\n  from {\n    opacity: 0;\n    transform: translateY(-50px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes fadeInUp {\n  from {\n    opacity: 0;\n    transform: translateY(50px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes float {\n  0% {\n    transform: translateY(0);\n  }\n  50% {\n    transform: translateY(-10px);\n  }\n  100% {\n    transform: translateY(0);\n  }\n}\n\n/* Mission Section */\n.mission-section {\n  padding: 0px 20px;\n  text-align: center;\n  background-color: #f9f9f9;\n}\n\n.mission-section h2 {\n  font-family: \"Montserrat\", sans-serif;\n  font-size: 2.5rem;\n  margin-bottom: 15px;\n  font-weight: 20px;\n}\n\n.mission-description {\n  font-family: \"Montserrat\", sans-serif;\n  font-size: 1.1rem;\n  color: #555;\n  max-width: 1200px;\n  margin: 0 auto;\n  line-height: 1.6;\n  margin-bottom: 50px;\n  text-align: start;\n}\n\n.mission-cards {\n  display: flex;\n  justify-content: center;\n  flex-wrap: wrap;\n  gap: 20px;\n}\n\n.mission-card {\n  background-color: white;\n  padding: 20px;\n  border-radius: 0px;\n  width: 300px;\n  height: 200px;\n  text-align: center;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  transition: all 0.3s ease;\n  cursor: pointer;\n  color: white;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-size: cover;\n  background-position: center;\n}\n\n.mission-card h3 {\n  font-family: \"Montserrat\", sans-serif;\n  font-size: 1.5rem;\n  margin-bottom: 10px;\n}\n\n.mission-card:hover {\n  transform: translateY(-10px);\n  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);\n}\n\n/* Features Section */\n.features-section {\n  padding: 80px 20px;\n  text-align: center;\n  background-color: white;\n}\n\n.features-section h2 {\n  font-family: \"Montserrat\", sans-serif;\n  font-size: 2.5rem;\n  margin-bottom: 40px;\n}\n\n.features-grid {\n  display: flex;\n  justify-content: center;\n  flex-wrap: wrap;\n  gap: 20px;\n}\n\n.feature-card {\n  background-color: #f9f9f9;\n  padding: 30px;\n  border-radius: 10px;\n  width: 300px;\n  text-align: start;\n  transition: all 0.3s ease;\n  font-family: \"Montserrat\", sans-serif;\n  position: relative;\n}\n\n.feature-card:hover {\n  transform: translateY(-10px);\n  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);\n}\n\n.feature-icon {\n  font-size: 3rem;\n  color: #ff6b6b;\n  margin-bottom: 20px;\n}\n\n.feature-card h3 {\n  font-family: \"Montserrat\", sans-serif;\n  font-size: 1.5rem;\n  margin-bottom: 10px;\n}\n\n.feature-card p {\n  font-family: \"Montserrat\", sans-serif;\n  font-size: 1.1rem;\n  color: #555;\n}\n\n/* Nature Mission Card Specific Styles */\n.nature-mission-card {\n  position: relative;\n  overflow: hidden;\n  background: linear-gradient(135deg, #3c433c, #45a049) !important;\n  color: white !important;\n  text-decoration: none;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: space-between;\n  padding-bottom: 50px;\n}\n\n.nature-mission-card .feature-icon {\n  color: white !important;\n}\n\n.nature-mission-card h3,\n.nature-mission-card p {\n  color: white !important;\n}\n\n.nature-mission-card .learn-more {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background: rgba(255, 255, 255, 0.1);\n  padding: 12px 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  transition: all 0.3s ease;\n  backdrop-filter: blur(5px);\n  border-top: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n.nature-mission-card:hover .learn-more {\n  background: rgba(255, 255, 255, 0.2);\n  padding-left: 20px;\n  padding-right: 20px;\n}\n\n.nature-mission-card .learn-more span {\n  font-size: 0.95rem;\n  font-weight: 600;\n  color: white;\n}\n\n.nature-mission-card .arrow-icon {\n  font-size: 0.9rem;\n  color: white;\n  transition: transform 0.3s ease;\n}\n\n.nature-mission-card:hover .arrow-icon {\n  transform: translateX(5px);\n}\n\n.nature-mission-card:hover {\n  transform: translateY(-10px) scale(1.02);\n  box-shadow: 0 15px 30px rgba(76, 175, 80, 0.3);\n}\n\n/* Testimonials Section */\n.testimonials-section {\n  padding: 80px 20px;\n  text-align: center;\n  background-color: #f9f9f9;\n}\n\n.testimonials-section h2 {\n  font-family: \"Montserrat\", sans-serif;\n  font-size: 2.5rem;\n  margin-bottom: 40px;\n}\n\n.testimonials-grid {\n  display: flex;\n  justify-content: center;\n  flex-wrap: wrap;\n  gap: 20px;\n}\n\n.testimonial-card {\n  background-color: white;\n  padding: 30px;\n  border-radius: 10px;\n  width: 300px;\n  text-align: start;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  transition: all 0.3s ease;\n}\n\n.testimonial-card:hover {\n  transform: translateY(-10px);\n  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);\n}\n\n.quote-icon {\n  font-size: 2rem;\n  color: #ff6b6b;\n  margin-bottom: 20px;\n}\n\n.testimonial-card p {\n  font-size: 1.1rem;\n  color: #555;\n  margin-bottom: 10px;\n  font-family: \"Montserrat\", sans-serif;\n}\n\n/* Call-to-Action Section */\n.cta-section {\n  padding: 40px 20px;\n  text-align: center;\n  background: linear-gradient(135deg, #1e3c72, #2a5298);\n  color: white;\n  position: relative;\n  overflow: hidden;\n}\n\n.cta-section::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.1);\n  z-index: 1;\n}\n\n.cta-content {\n  position: relative;\n  z-index: 2;\n  max-width: 800px;\n  margin: 0 auto;\n}\n\n.cta-section h2 {\n  font-size: 2.5rem;\n  margin-bottom: 20px;\n  font-weight: bold;\n  animation: fadeInDown 1.5s ease;\n}\n\n.cta-section p {\n  font-size: 1.2rem;\n  margin-bottom: 40px;\n  animation: fadeInUp 1.5s ease;\n}\n\n.cta-section button {\n  padding: 15px 30px;\n  font-size: 1.2rem;\n  background-color: white;\n  color: #6a11cb;\n  border: none;\n  border-radius: 50px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  animation: pulse 2s infinite;\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);\n}\n\n.cta-section button:hover {\n  background-color: #f0f0f0;\n  transform: translateY(-5px);\n  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.3);\n}\n\n@keyframes pulse {\n  0% {\n    transform: scale(1);\n  }\n  50% {\n    transform: scale(1.05);\n  }\n  100% {\n    transform: scale(1);\n  }\n}\n\n/* FOOTER - COMPLETE FIX FOR ALL SCREEN SIZES */\n.footer {\n  padding: 50px 20px 20px 20px;\n  background-color: #333;\n  color: white;\n  font-family: \"Montserrat\", sans-serif;\n  width: 100%;\n  box-sizing: border-box;\n  position: relative;\n  z-index: 1;\n}\n\n.footer-content {\n  display: flex;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 40px;\n  max-width: 1200px;\n  margin: 0 auto 40px auto;\n  padding: 0 20px;\n  position: relative;\n  z-index: 10;\n}\n\n.footer-section {\n  flex: 1;\n  min-width: 250px;\n  max-width: 300px;\n  position: relative;\n  z-index: 20;\n}\n\n.footer-section h3 {\n  font-size: 1.5rem;\n  margin-bottom: 20px;\n  color: white;\n  font-weight: 600;\n  position: relative;\n  padding-bottom: 10px;\n}\n\n.footer-section p {\n  font-size: 1rem;\n  color: #ccc;\n  line-height: 1.6;\n  margin-bottom: 10px;\n}\n\n.footer-section ul {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  position: relative;\n  z-index: 20;\n}\n\n.footer-section ul li {\n  margin-bottom: 12px;\n  position: relative;\n  z-index: 20;\n}\n\n.footer-section ul li a {\n  color: #ccc;\n  text-decoration: none;\n  transition: color 0.3s ease;\n  font-size: 1rem;\n  display: inline-block;\n  padding: 4px 0;\n  position: relative;\n  z-index: 30;\n  pointer-events: auto;\n}\n\n.footer-section ul li a:hover {\n  color: #ff6b6b;\n  transform: translateX(5px);\n}\n\n\n.footer-section .social-links {\n  display: flex;\n  gap: 4px;\n  margin-top: 10px;\n  position: relative;\n  z-index: 1000;\n  justify-content: flex-start; \n  margin-left: 0;\n}\n\n.footer-section .social-links a {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  text-decoration: none !important;\n  transition: all 0.3s ease;\n  position: relative;\n  z-index: 1001;\n  cursor: pointer !important;\n  pointer-events: auto !important;\n  outline: none;\n  border: none;\n  background-clip: padding-box;\n}\n\n\n.footer-section .social-links a,\n.footer-section .social-links a:focus,\n.footer-section .social-links a:active,\n.footer-section .social-links a:visited {\n  text-decoration: none !important;\n  outline: none !important;\n}\n\n/* Facebook */\n.footer-section .social-links a:nth-child(1) {\n  background-color: #1877F2 !important;\n}\n\n.footer-section .social-links a:nth-child(1):hover {\n  background-color: #0d65d9 !important;\n  transform: translateY(-3px) scale(1.1);\n  box-shadow: 0 4px 12px rgba(24, 119, 242, 0.3);\n}\n\n\n.footer-section .social-links a:nth-child(2) {\n  background-color: #0077B5 !important;\n  position: relative;\n  z-index: 1002 !important;\n}\n\n.footer-section .social-links a:nth-child(2):hover {\n  background-color: #005582 !important;\n  transform: translateY(-3px) scale(1.1);\n  box-shadow: 0 4px 12px rgba(0, 119, 181, 0.3);\n}\n\n/* Social link icons */\n.footer-section .social-links a svg {\n  color: white !important;\n  font-size: 1.2rem;\n  position: relative;\n  z-index: 1003;\n  pointer-events: none;\n}\n\n/* LEGAL LINKS SECTION */\n.footer-legal-links {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: 20px;\n  padding: 15px 10px;\n  border-top: 1px solid #444;\n  border-bottom: 1px solid #444;\n  background: transparent;\n  position: relative;\n  z-index: 5;\n  margin-top: 20px;\n}\n\n.footer-legal-links a {\n  font-size: 0.85rem;\n  color: #aaa;\n  text-decoration: none;\n  font-family: \"Montserrat\", sans-serif;\n  transition: all 0.3s ease;\n  white-space: nowrap;\n  position: relative;\n  z-index: 5;\n  pointer-events: auto;\n}\n\n/* Fix for refund link */\n.footer-legal-links a:nth-child(4) {\n  max-width: 120px;\n  text-align: center;\n  word-break: break-word;\n  white-space: normal;\n  line-height: 1.3;\n}\n\n.footer-legal-links a:hover {\n  color: #ff6b6b;\n  text-decoration: underline;\n}\n\n.contactus-footer {\n  text-align: center;\n  margin-top: 20px;\n  padding-top: 20px;\n  width: 100%;\n  max-width: 1200px;\n  margin-left: auto;\n  margin-right: auto;\n  position: relative;\n  z-index: 5;\n  border-top: 1px solid #444;\n}\n\n.contactus-footer p {\n  font-size: 0.9rem;\n  color: #aaa;\n  margin: 0;\n  padding: 0 20px;\n}\n\n/* Pop-up Overlay */\n.popup-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.7);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n/* Pop-up Content */\n.popup-content {\n  background: white;\n  padding: 30px;\n  border-radius: 10px;\n  text-align: center;\n  max-width: 1200px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n  position: relative;\n  font-family: \"Montserrat\", sans-serif;\n}\n\n/* Close Icon */\n.close-icon {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  font-size: 1.5rem;\n  color: #6f6969;\n  cursor: pointer;\n  transition: color 0.3s ease;\n}\n\n.close-icon:hover {\n  color: #837979;\n}\n\n\n\n/* For LARGE DESKTOPS (15\" and above) - Social icons */\n@media (min-width: 1200px) {\n  .footer-section .social-links {\n    justify-content: flex-start;\n    margin-left: 0;\n    padding-left: 0;\n  }\n}\n\n/* For MEDIUM DESKTOPS/LAPTOPS (13\"-14\")  */\n@media (min-width: 992px) and (max-width: 1199px) {\n  .footer-section .social-links {\n    justify-content: flex-start;\n    margin-left: 0;\n    padding-left: 0;\n  }\n  \n  .footer-content {\n    gap: 30px;\n  }\n  \n  .footer-section {\n    min-width: 220px;\n  }\n}\n\n/* For SMALL DESKTOPS/TABLETS (11\"-12\")  */\n@media (min-width: 768px) and (max-width: 991px) {\n  .footer-section .social-links {\n    justify-content: flex-start;\n    margin-left: 0;\n    padding-left: 0;\n  }\n  \n  .footer-content {\n    gap: 20px;\n  }\n  \n  .footer-section {\n    min-width: 200px;\n  }\n  \n  .hero-content h1 {\n    font-size: 2.2rem;\n  }\n  \n  .mission-card,\n  .feature-card,\n  .testimonial-card {\n    width: calc(50% - 20px);\n  }\n}\n\n/* For TABLETS and MOBILE (below 768px)*/\n@media (max-width: 767px) {\n  .footer-section .social-links {\n    justify-content: center;\n  }\n  \n  .hero-content h1 {\n    font-size: 2rem;\n  }\n\n  .hero-content p {\n    font-size: 1rem;\n  }\n\n  .mission-card,\n  .feature-card,\n  .testimonial-card {\n    width: 100%;\n  }\n\n  .cta-section h2 {\n    font-size: 2rem;\n  }\n\n  .cta-section p {\n    font-size: 1rem;\n  }\n\n  /* Footer Responsive */\n  .footer {\n    padding: 40px 15px 15px 15px;\n  }\n  \n  .footer-content {\n    flex-direction: column;\n    gap: 30px;\n    padding: 0 10px;\n    margin-bottom: 30px;\n    align-items: center;\n    text-align: center;\n  }\n  \n  .footer-section {\n    min-width: 100%;\n    max-width: 100%;\n    text-align: center;\n    padding: 0 10px;\n  }\n  \n  .contactus-footer {\n    padding-top: 15px;\n    margin-top: 15px;\n  }\n  \n  .contactus-footer p {\n    font-size: 0.8rem;\n  }\n  \n  /* Social links mobile */\n  .footer-section .social-links a {\n    width: 36px;\n    height: 36px;\n  }\n  \n  .footer-section .social-links a svg {\n    font-size: 1rem;\n  }\n  \n  /* Legal links mobile */\n  .footer-legal-links {\n    gap: 10px;\n  }\n  \n  .footer-legal-links a {\n    font-size: 0.8rem;\n    padding: 4px 8px;\n  }\n  \n  .footer-legal-links a:nth-child(4) {\n    max-width: 100px;\n  }\n}\n\n/* For SMALL MOBILE (below 480px) */\n@media (max-width: 480px) {\n  .hero-content h1 {\n    font-size: 1.8rem;\n  }\n\n  .hero-content p {\n    font-size: 0.9rem;\n  }\n\n  .mission-section h2,\n  .features-section h2,\n  .testimonials-section h2 {\n    font-size: 2rem;\n  }\n\n  .mission-card,\n  .feature-card,\n  .testimonial-card {\n    width: 100%;\n    padding: 20px;\n  }\n\n  .cta-section h2 {\n    font-size: 1.8rem;\n  }\n\n  .cta-section button {\n    padding: 12px 24px;\n    font-size: 1rem;\n  }\n\n  /* Footer Responsive */\n  .footer {\n    padding: 30px 10px 10px 10px;\n  }\n  \n  .footer-content {\n    gap: 25px;\n  }\n  \n  .footer-section h3 {\n    font-size: 1.3rem;\n    margin-bottom: 15px;\n  }\n  \n  .footer-section p, \n  .footer-section ul li a {\n    font-size: 0.9rem;\n  }\n  \n  .footer-section .social-links a {\n    width: 32px;\n    height: 32px;\n  }\n  \n  .footer-section .social-links a svg {\n    font-size: 0.9rem;\n  }\n  \n  .footer-legal-links {\n    gap: 8px;\n  }\n  \n  .footer-legal-links a {\n    font-size: 0.75rem;\n  }\n}\n\n/* For VERY SMALL MOBILE (below 360px) */\n@media (max-width: 360px) {\n  .footer-section .social-links {\n    gap: 10px;\n  }\n  \n  .footer-section .social-links a {\n    width: 30px;\n    height: 30px;\n  }\n  \n  .footer-section .social-links a svg {\n    font-size: 0.85rem;\n  }\n}\n\n@media (max-width: 768px) {\n  .footer-section p {\n    text-align: center;\n    max-width: 300px;\n    width: 100%;\n    margin-left: auto;\n    margin-right: auto;\n    line-height: 1.7;\n    word-break: break-word;\n  }\n}\n/* Desktop & Laptop lo Follow Us icons inka left ki move */\n\n@media (min-width: 768px) {\n\n  /* Follow Us heading */\n  .footer-section h3 {\n    margin-left: -40px;\n  }\n\n   .footer-section p {\n    margin-left: -40px;\n  }\n\n\n  /* Social icons */\n  .footer-section .social-links {\n    margin-left: -40px;\n  }\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
